import React, { useState } from "react";
import Select, {components} from 'react-select';
import IconSearch from "../icon/icon-search";
import { useIsMobile900 } from "../../../hooks/mobile";
import { henleyFlagLink } from "../../../utils/utils";
import styles from './react-select-custom.module.scss';
import IconArrowDown from "../icon/icon-arrow-down";


const SelectCustom = ({
  value,
  options,
  onChange,
  onBlur,
  placeholder,
  isClearable,
  isSearchable,
  darkTheme = false,
  selectType
}) => {

    const isMobile = useIsMobile900();

    // Custom filter function - only show countries that start with the typed text
    const filterOption = (option, inputValue) => {
      if (!inputValue) return true;

      const label = option.label.toLowerCase();
      const search = inputValue.toLowerCase();

      // Only show options that start with the search text
      return label.startsWith(search);
    };

    const dropDownIndicator = (props) => {
        return (
          components.DropdownIndicator && (
            <components.DropdownIndicator {...props}>
              {isSearchable ? <IconSearch /> : <IconArrowDown />}
            </components.DropdownIndicator>
          )
        );
    };

    const FlagImage = ({ code, label }) => {
          const [imageError, setImageError] = useState(false);
          const flagUrl = henleyFlagLink(code);

          const handleImageError = () => {
              // console.log(`Flag image failed to load for ${label} (${code}): ${flagUrl}`);
              setImageError(true);
          };

          if (imageError || !flagUrl) {
              return (
                  <div style={{
                      height: '24px',
                      width: '24px',
                      borderRadius: '50%',
                      marginRight: '10px',
                      border: '1px solid #C1C5C8',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      backgroundColor: '#f5f5f5',
                      fontSize: '10px',
                      fontWeight: 'bold',
                      color: '#405363'
                  }}>
                      {code && code !== 'None' ? code.toUpperCase() : '??'}
                  </div>
              );
          }

          return (
              <img
                  src={flagUrl}
                  style={{ height: '24px', width: '24px', borderRadius: '50%', marginRight: '10px', border:'1px solid #C1C5C8' }}
                  alt={label}
                  onError={handleImageError}
              />
          );
    };

    const optionCustom = (props) => {
          return(
            <components.Option {...props}>
                <div className={styles.optionContent}>
                  {selectType === "passport" && (
                      <FlagImage code={props.data.value} label={props.data.label} />
                  )}
                  <span className={styles.optionText}>{props.data.label} </span>
                </div>
            </components.Option>
          );
    };

    const selectStyles = {
        menu: (provided) => ({
          ...provided,
          zIndex: 100,
          backgroundColor:'#fff',
          borderRadius: 0,
          paddingLeft: 10,
          paddingRight: 10
        }),
        input: (provided) => ({
          ...provided,
          color: darkTheme ? "#fff" : "#405363",
        }),
        control: (provided) => ({
          ...provided,
          background: "transparent",
          border: "none",
          boxShadow: "none",
          borderRadius: 0,
          color: darkTheme ? "#fff" : "#405363",
          padding:0,
          borderBottom: darkTheme ? "1px solid #fff" : "1px solid #979797"
        }),
        dropdownIndicator: (provided) => ({
          ...provided,
          color: darkTheme ? "#fff" : "#405363",
          padding: isMobile ? 14 : 12,
        }),
        placeholder: (provided) => ({
          ...provided,
          color: darkTheme ? "#fff" : "#405363",
          fontFamily: "Garamond Regular",
          fontSize: isMobile ? 14: 16,
        //   paddingLeft: 16,
        }),
        indicatorSeparator: (provided) => ({
          ...provided,
          display: "none",
        }),
        singleValue: (provided) => ({
          ...provided,
          color: darkTheme ? "#fff" : "#405363",
          fontFamily: "Garamond Regular",
          fontSize: isMobile ? 14 : 16,
        //   paddingLeft: 10,
        }),
        valueContainer: (provided) => ({
          ...provided,
          padding: "0 0 8px 0",
        }),
        indicatorsContainer: (provided) => ({
          ...provided,
          background: "transparent",
          color: "#C1C5C8",
        }),
        option: (provided, state) => ({
          ...provided,
          fontSize: isMobile ? 14 : 18,
          backgroundColor: state.isFocused
            ? "#C1C5C8"
            : state.isDisabled
            ? "#f3f3f3"
            : null,
          color: state.isFocused
            ? "#405363"
            : state.isDisabled
            ? "#405363"
            : "",
          opacity: state.isDisabled
            ? "0.5"
            : "1",
          cursor: state.isDisabled
            ? 'not-allowed'
            : 'pointer'
        }),
    };
    
    return(
        <>
            <Select
                value={value}
                options={options}
                onChange={onChange}
                onBlur={onBlur}
                isClearable={isClearable}
                isSearchable={isSearchable}
                filterOption={filterOption}
                //menuIsOpen
                placeholder={placeholder}
                components={{ DropdownIndicator:dropDownIndicator, Option: optionCustom}}
                blurInputOnSelect={true}
                styles={selectStyles}
            />
        </>
    );
}

export default SelectCustom;